module.exports = __webpack_public_path__ + "img/68_M10_watch_weather.4b310275.jpg";